<template>
  <div class="container">
    <div style="height: 12rem;overflow: auto">
      <div class="fs-28 flex-row-bc item" v-for="item in packingFeeDetail.value.packingFeeDetail" v-if="item.packing_fee != '0'">
        <div>{{item.title}}</div>
        <div class="fs-24">
          <span class="c-gray" style="padding-right: .24rem">{{item.subTitle}}</span>
          {{item.value}}
        </div>
      </div>
    </div>

    <div style="position: fixed;bottom: .4rem;left:.32rem;right:.32rem;line-height: .46rem;" v-html="packingFeeDetail.value.description"></div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        packingFeeDetail: {},
        description: ''
      }
    },
    created () {
      if (localStorage.getItem('packingFeeDetail')) {
        this.packingFeeDetail = JSON.parse(localStorage.getItem('packingFeeDetail'));
        // this.packingFeeDetail.value = JSON.parse(this.packingFeeDetail.value);
        if (this.packingFeeDetail.value.description) {
          this.packingFeeDetail.value.description = this.packingFeeDetail.value.description.replace(/\n/g, "<br />");
        }
        if (this.packingFeeDetail.title) {
          document.title = this.packingFeeDetail.title;
        }
      }
    }

  }
</script>
<style scoped>
  .container{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: .32rem;
    background-color: #fff;
  }
  .container .item{
    padding-bottom: .24rem;
  }
</style>



// WEBPACK FOOTER //
// packingFee.vue?573cdabc